import { Injectable, inject } from '@angular/core';
import { isBoolean } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

import { LOCAL_STORAGE_TOKEN } from '@core/domTokens';

@Injectable()
export class SideMenuService {
  public readonly minimized = new BehaviorSubject(false);

  constructor() {
    const localStorage = inject<Storage>(LOCAL_STORAGE_TOKEN);

    try {
      const initValue = JSON.parse(localStorage.getItem('sideMenuMinimized') ?? 'false');
      this.minimized.next(isBoolean(initValue) ? initValue : false);
    } catch (e) {
      console.error('Error while parsing sideMenuMinimized from localStorage: ', e);
      this.minimized.next(false);
    }
    this.minimized.subscribe((value) => {
      localStorage.setItem('sideMenuMinimized', JSON.stringify(value));
    });
  }
}
